export default {

    config: {
        "query": {
            "from": 0,
            "size": 25,
            "sort": [{"_score": {"order": "desc"}}],
            "query": {
                "function_score": {
                    "query": {
                        "bool": {
                            "should": [{
                                "bool": {
                                    "must": [{
                                        "bool": {
                                            "should": [{
                                                "multi_match": {
                                                    "query": "ep_autosuggest_placeholder",
                                                    "type": "phrase",
                                                    "fields": ["post_title^1", "post_excerpt^1", "post_content^1", "post_author.display_name^1", "terms.post_tag.name^1", "terms.category.name^1", "terms.ep_custom_result.name^9999", "_kit_text^1"],
                                                    "boost": 3
                                                }
                                            }, {
                                                "multi_match": {
                                                    "query": "ep_autosuggest_placeholder",
                                                    "fields": ["post_title^1", "post_excerpt^1", "post_content^1", "post_author.display_name^1", "terms.post_tag.name^1", "terms.category.name^1", "post_title.suggest^1", "term_suggest^1", "_kit_text^1"],
                                                    "boost": 1,
                                                    "fuzziness": "auto",
                                                    "operator": "and"
                                                }
                                            }, {
                                                "multi_match": {
                                                    "query": "ep_autosuggest_placeholder",
                                                    "type": "cross_fields",
                                                    "fields": ["post_title^1", "post_excerpt^1", "post_content^1", "post_author.display_name^1", "terms.post_tag.name^1", "terms.category.name^1", "terms.ep_custom_result.name^1", "_kit_text^1"],
                                                    "boost": 1,
                                                    "analyzer": "standard",
                                                    "tie_breaker": 0.5,
                                                    "operator": "and"
                                                }
                                            }]
                                        }
                                    }], "filter": [{"match": {"post_type.raw": "post"}}]
                                }
                            }, {
                                "bool": {
                                    "must": [{
                                        "bool": {
                                            "should": [{
                                                "multi_match": {
                                                    "query": "ep_autosuggest_placeholder",
                                                    "type": "phrase",
                                                    "fields": ["post_title^1", "post_excerpt^1", "post_content^1", "post_author.display_name^1", "terms.ep_custom_result.name^9999", "_kit_text^1"],
                                                    "boost": 3
                                                }
                                            }, {
                                                "multi_match": {
                                                    "query": "ep_autosuggest_placeholder",
                                                    "fields": ["post_title^1", "post_excerpt^1", "post_content^1", "post_author.display_name^1", "post_title.suggest^1", "_kit_text^1"],
                                                    "boost": 1,
                                                    "fuzziness": "auto",
                                                    "operator": "and"
                                                }
                                            }, {
                                                "multi_match": {
                                                    "query": "ep_autosuggest_placeholder",
                                                    "type": "cross_fields",
                                                    "fields": ["post_title^1", "post_excerpt^1", "post_content^1", "post_author.display_name^1", "terms.ep_custom_result.name^1", "_kit_text^1"],
                                                    "boost": 1,
                                                    "analyzer": "standard",
                                                    "tie_breaker": 0.5,
                                                    "operator": "and"
                                                }
                                            }]
                                        }
                                    }], "filter": [{"match": {"post_type.raw": "page"}}]
                                }
                            }, {
                                "bool": {
                                    "must": [{
                                        "bool": {
                                            "should": [{
                                                "multi_match": {
                                                    "query": "ep_autosuggest_placeholder",
                                                    "type": "phrase",
                                                    "fields": ["post_title^1", "post_excerpt^1", "post_content^1", "post_author.display_name^1", "terms.ep_custom_result.name^9999", "_kit_text^1"],
                                                    "boost": 3
                                                }
                                            }, {
                                                "multi_match": {
                                                    "query": "ep_autosuggest_placeholder",
                                                    "fields": ["post_title^1", "post_excerpt^1", "post_content^1", "post_author.display_name^1", "post_title.suggest^1", "_kit_text^1"],
                                                    "boost": 1,
                                                    "fuzziness": "auto",
                                                    "operator": "and"
                                                }
                                            }, {
                                                "multi_match": {
                                                    "query": "ep_autosuggest_placeholder",
                                                    "type": "cross_fields",
                                                    "fields": ["post_title^1", "post_excerpt^1", "post_content^1", "post_author.display_name^1", "terms.ep_custom_result.name^1", "_kit_text^1"],
                                                    "boost": 1,
                                                    "analyzer": "standard",
                                                    "tie_breaker": 0.5,
                                                    "operator": "and"
                                                }
                                            }]
                                        }
                                    }], "filter": [{"match": {"post_type.raw": "project"}}]
                                }
                            }, {
                                "bool": {
                                    "must": [{
                                        "bool": {
                                            "should": [{
                                                "multi_match": {
                                                    "query": "ep_autosuggest_placeholder",
                                                    "type": "phrase",
                                                    "fields": ["post_title^1", "post_excerpt^1", "post_content^1", "post_author.display_name^1", "terms.ep_custom_result.name^9999", "_kit_text^1"],
                                                    "boost": 3
                                                }
                                            }, {
                                                "multi_match": {
                                                    "query": "ep_autosuggest_placeholder",
                                                    "fields": ["post_title^1", "post_excerpt^1", "post_content^1", "post_author.display_name^1", "post_title.suggest^1", "_kit_text^1"],
                                                    "boost": 1,
                                                    "fuzziness": "auto",
                                                    "operator": "and"
                                                }
                                            }, {
                                                "multi_match": {
                                                    "query": "ep_autosuggest_placeholder",
                                                    "type": "cross_fields",
                                                    "fields": ["post_title^1", "post_excerpt^1", "post_content^1", "post_author.display_name^1", "terms.ep_custom_result.name^1", "_kit_text^1"],
                                                    "boost": 1,
                                                    "analyzer": "standard",
                                                    "tie_breaker": 0.5,
                                                    "operator": "and"
                                                }
                                            }]
                                        }
                                    }], "filter": [{"match": {"post_type.raw": "event"}}]
                                }
                            }]
                        }
                    },
                    "functions": [{
                        "exp": {
                            "post_date_gmt": {
                                "scale": "14d",
                                "decay": 0.25,
                                "offset": "7d"
                            }
                        }
                    }, {"weight": 0.001}],
                    "score_mode": "sum",
                    "boost_mode": "multiply"
                }
            },
            "post_filter": {"bool": {"must": [{"terms": {"post_type.raw": ["post", "page", "project", "event"]}}, {"term": {"post_status": "publish"}}, {"terms": {"post_type.raw": ["post", "page", "event", "project"]}}]}}
        },
        "placeholder": "ep_autosuggest_placeholder",
        "endpointUrl": "\/cms\/index.php?rest_route=elasticpress\/autosuggest",
        "selector": ".ep-autosuggest",
        "defaultSelectors": ".ep-autosuggest, input[type=\"search\"], .search-field",
        "action": "navigate",
        "mimeTypes": [],
        "http_headers": [],
        "triggerAnalytics": "",
        "addSearchTermHeader": ""
    }
}
